import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "../store/index"
import AddressComplete from '../views/AddressComplete.vue';
import SaisirPaiementPaysafe from '../views/SaisirPaiementPaysafe.vue';
import Unauthorized from "../views/UnauthorizedView.vue";
import VueMeta from 'vue-meta';
import constants from "../constants"

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
});

const routes = [
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized
  },
  {
    path: '/address-complete',
    name: 'AddressComplete',
    component: AddressComplete,
    meta: { requireAuth: true, authType: constants.AUTH_TYPE.SPECIF }
  },
  {
    path: '/paiement-paysafe',
    name: 'SaisirPaiementPaysafe',
    component: SaisirPaiementPaysafe,
    meta: { requireAuth: true, authType: constants.AUTH_TYPE.SPECIF }
  }
];

const router = new VueRouter({
  mode: 'hash',
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!store.getters["authStore/isAuthenticated"] && to.query.token) {
      store.$axios.updateAuthentification(to.meta.authType, to.query.token)
      await store.dispatch("authStore/eudonetSpecifAuth")
    }

    if (store.getters["authStore/isAuthenticated"]) {
      next()
    } else {
      next({
        name: "unauthorized"
      })
    }
  } else {
    next()
  }
})

export default router;